/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaAdStructureGetMetaAdCampaignByCampaignId } from '../../axios/metaAdStructureGetMetaAdCampaignByCampaignId'
import type {
	MetaAdStructureGetMetaAdCampaignByCampaignIdError,
	MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams,
	MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
} from '../../types/MetaAdStructureGetMetaAdCampaignByCampaignId'

export const metaAdStructureGetMetaAdCampaignByCampaignIdQueryKey = (
	campaignId: MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams['campaignId'],
) => [{ url: '/meta/ad-campaign/campaign/:campaignId', params: { campaignId } }] as const

export type MetaAdStructureGetMetaAdCampaignByCampaignIdQueryKey = ReturnType<
	typeof metaAdStructureGetMetaAdCampaignByCampaignIdQueryKey
>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::getMetaAdCampaignByCampaignId */
export function metaAdStructureGetMetaAdCampaignByCampaignIdQueryOptions(
	campaignId: MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams['campaignId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
		AxiosError<MetaAdStructureGetMetaAdCampaignByCampaignIdError>,
		MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
		MetaAdStructureGetMetaAdCampaignByCampaignIdQueryKey
	>({
		queryKey: metaAdStructureGetMetaAdCampaignByCampaignIdQueryKey(campaignId),
		queryFn: ({ signal }) =>
			metaAdStructureGetMetaAdCampaignByCampaignId(campaignId, { signal, ...config }).then(res => res.data),
		enabled: !!campaignId,
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::getMetaAdCampaignByCampaignId */
export function useMetaAdStructureGetMetaAdCampaignByCampaignId<
	TSelectData = MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
>(
	campaignId: MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams['campaignId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
					AxiosError<MetaAdStructureGetMetaAdCampaignByCampaignIdError>,
					TSelectData,
					MetaAdStructureGetMetaAdCampaignByCampaignIdQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaAdStructureGetMetaAdCampaignByCampaignIdError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaAdStructureGetMetaAdCampaignByCampaignIdQueryOptions(campaignId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::getMetaAdCampaignByCampaignId */
export function useMetaAdStructureGetMetaAdCampaignByCampaignIdSuspense<
	TSelectData = MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
>(
	campaignId: MetaAdStructureGetMetaAdCampaignByCampaignIdPathParams['campaignId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaAdStructureGetMetaAdCampaignByCampaignIdResponse,
					AxiosError<MetaAdStructureGetMetaAdCampaignByCampaignIdError>,
					TSelectData,
					MetaAdStructureGetMetaAdCampaignByCampaignIdQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaAdStructureGetMetaAdCampaignByCampaignIdError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaAdStructureGetMetaAdCampaignByCampaignIdQueryOptions(campaignId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
